import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../../../components/auth/auth.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { HotkeysService, Hotkey } from 'angular2-hotkeys';
import {
  NgbModal,
  NgbModalConfig,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import moment from 'moment';
import { CommonReportService } from '../../../app/shared/services/CommonReportService.service';

@Component({
  selector: 'mrlogin',
  template: require('./mrlogin.html'),
})
export class MRLoginComponent implements OnInit {
  AuthService;
  Router;
  public userInfo: any;
  gridApiMonthlySales: any;
  gridApiItemSales: any;
  gridApiCustomerSales: any;
  gridApiAllowNonMoving: any;
  gridApiAllowNearExpiry: any;
  gridApiAllowPendingClaim: any;
  gridColumnApiMonthlySales: any;
  gridColumnApiItemSales: any;
  gridColumnApiCustomerSales: any;
  gridColumnApiAllowNonMoving: any;
  gridColumnApiAllowNearExpiry: any;
  gridColumnApiAllowPendingClaim: any;
  public defaultColDefMonthlySales: any;
  public defaultColDefItemSales: any;
  public defaultColDefCustomerSales: any;
  public defaultColDefNV:any;
  public defaultColDefNEXP:any;
  public defaultColDefPCLM:any;
  monthlysalesdataList: any;
  itemcustomersalesdataList: any;
  customeritemsalesdataList: any;
  AllowNonMovingdataList: any;
  AllowNearExpirydataList: any;
  AllowPendingClaimdataList: any;
  overlayNoRowsTemplate: any;
  MonthlySalesColumnDefs: any;
  ItemSalesColumnDefs: any;
  CustomerSalesColumnDefs: any;
  AllowNonMovingColumnDefs: any;
  AllowNearExpiryColumnDefs: any;
  AllowPendingClaimColumnDefs: any;
  Division_ID: any = 0;

  reportModel: any = {
    1: {
      name: 'Monthly SS',
      procedure: 'Get_MR_MSS',
      isViewLoading: 0,
      isExportLoading: 0,
      repeatCount: 0,
    },
    2: {
      name: 'Item Customer Wise Monthly SS',
      procedure: 'Get_MR_ItemCustomerSales_Data',
      isViewLoading: 0,
      isExportLoading: 0,
      repeatCount: 0,
    },
    3: {
      name: 'Customer Item Wise Monthly SS',
      procedure: 'Get_MR_ItemCustomerSales_Data',
      isViewLoading: 0,
      isExportLoading: 0,
      repeatCount: 0,
    },
    4: {
      name: 'Non Moving Product List',
      procedure: 'Get_MR_NonMoving_NearExpiry_PendingClaim_Data',
      isViewLoading: 0,
      isExportLoading: 0,
      repeatCount: 0,
    },
    5: {
      name: 'Near Expiry Product List',
      procedure: 'Get_MR_NonMoving_NearExpiry_PendingClaim_Data',
      isViewLoading: 0,
      isExportLoading: 0,
      repeatCount: 0,
    },
    6: {
      name: 'Pending Claim Summary',
      procedure: 'Get_MR_NonMoving_NearExpiry_PendingClaim_Data',
      isViewLoading: 0,
      isExportLoading: 0,
      repeatCount: 0,
    },
  };
  overlayLoadingTemplate =
    '<span class="ag-overlay-loading-center">Please wait, data is loading ...</span>';

  static parameters = [
    AuthService,
    Router,
    HttpClient,
    HotkeysService,
    NgbModal,
    NgbModalConfig,
    CommonReportService
  ];
  busy!: Subscription;
  modalReference!: NgbModalRef;
  MR_name: any;
  ParamName: any;
  ParamTableData: any;
  public hotkeyList!: Hotkey[];
  public hotkeyListModal!: Hotkey[];
  public bsConfig: any;
  public mrMonthlysales: any;
  public mrItemsales: any;
  public mrCustomersales: any;
  public mrAllowNonMoving: any;
  public mrAllowNearExpiry: any;
  public mrAllowPendingClaim: any;
  Value_Type: any;
  Fname: any;

  constructor(_AuthService_: AuthService,
    private router: Router,
    private http: HttpClient,
    private hotkeysService: HotkeysService,
    private modalService: NgbModal,
    config: NgbModalConfig,
    public commonReportService: CommonReportService
  ) {
    this.AuthService = _AuthService_;
    this.http = http;
    this.router = router;
    this.hotkeysService = hotkeysService;
    this.bsConfig = Object.assign(
      {},
      {
        dateInputFormat: 'DD-MMM-YYYY',
        containerClass: 'theme-dark-blue',
      }
    );
    this.userInfo = JSON.parse(localStorage.getItem('user') as any);
/*      */
    this.MonthlySalesColumnDefs = [
      {
        headerName: 'Item Code',
        field: 'Product_Code',
        width: 50,
        headerTooltip: 'Item Code',
      },
      {
        headerName: 'Item Name',
        field: 'Product_Desc',
        width: 120,
        headerTooltip: 'Item Name',
      },
      {
        headerName: 'Packsize',
        field: 'Packsize',
        width: 50,
        headerTooltip: 'Packsize',
      },
      {
        headerName: 'Pur Rate',
        field: 'Prate',
        width: 70,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Pur Rate',
      },
      {
        headerName: 'PTR',
        field: 'PTR',
        width: 70,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'PTR',
      },
      {
        headerName: 'Opening',
        field: 'Opening_Qty',
        width: 60,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Opening',
      },
      {
        headerName: 'Pur Qty',
        field: 'Purchase_Qty',
        width: 50,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Pur Qty',
      },
      {
        headerName: 'Pur Free Qty',
        field: 'Purchase_Free_Qty',
        width: 40,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Pur Free Qty',
      },
      {
        headerName: 'Pur. Value',
        field: 'Purchase_Value',
        width: 80,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Pur Value',
      },
      {
        headerName: 'Pur Rtn Qty',
        field: 'Purchase_Ret_Qty',
        width: 50,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Pur Ret Qty',
      },
      {
        headerName: 'Pur Rtn Free Qty',
        field: 'Purchase_Ret_Free_Qty',
        width: 50,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Pur Ret Free Qty',
      },
      {
        headerName: 'Rpl Qty',
        field: 'Rqty',
        width: 50,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Rpl Qty',
      },
      {
        headerName: 'Sale Qty',
        field: 'Sale_Qty',
        width: 60,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Sale Qty',
      },
      {
        headerName: 'Sale Free Qty',
        field: 'Sale_Free_Qty',
        width: 50,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Sale Free Qty',
      },
      {
        headerName: 'Sale Val.',
        field: 'Sale_Value',
        width: 70,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Sale Value',
      },
      {
        headerName: 'Sale Rtn Qty',
        field: 'Sale_Ret_Qty',
        width: 50,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Sale Rtn Qty',
      },
      {
        headerName: 'Sale Rtn Free Qty',
        field: 'Sale_Ret_Free_Qty',
        width: 50,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Sale Rtn Free Qty',
      },
      {
        headerName: 'Oth Qty',
        field: 'Other_Qty',
        width: 50,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Other Qty',
      },
      {
        headerName: 'Closing',
        field: 'Closing_Qty',
        width: 70,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Closing',
      },
      {
        headerName: 'Sale Amt(PTR)',
        field: 'Sale_Amount',
        width: 80,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Sale Amt(PTR)',
      },
      {
        headerName: 'Stock Amt (Pur Rate)',
        field: 'Stock_Amount',
        width: 80,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Stock Amount(Pur Rate)',
      },
      {
        headerName: 'Status',
        field: 'Status',
        width: 50,
        headerTooltip: 'Status',
      },
    ];
    this.ItemSalesColumnDefs = [
      {
        headerName: 'Item Code',
        field: 'Product_Code',
        width: 100,
        headerTooltip: 'Item Code',
      },
      {
        headerName: 'Item Name',
        field: 'Product_Desc',
        width: 190,
        headerTooltip: 'Item Name',
      },
      {
        headerName: 'Packsize',
        field: 'Packsize',
        width: 80,
        headerTooltip: 'Packsize',
      },
      {
        headerName: 'Cust Code',
        field: 'Cust_Code',
        width: 100,
        headerTooltip: 'Cust Code',
      },
      {
        headerName: 'Customer Name',
        field: 'Cust_Name',
        width: 190,
        headerTooltip: 'Customer Name',
      },
      {
        headerName: 'Area',
        field: 'Area',
        width: 120,
        headerTooltip: 'Area',
      },
      {
        headerName: 'City',
        field: 'City',
        width: 170,
        headerTooltip: 'City',
      },
      {
        headerName: 'Pincode',
        field: 'Pincode',
        width: 70,
        headerTooltip: 'Pincode',
      },
      {
        headerName: 'Bill No',
        field: 'Bill_No',
        width: 70,
        headerTooltip: 'Bill No',
      },
      {
        headerName: 'Bill Date',
        field: 'Bill_Date',
        width: 70,
        headerTooltip: 'Bill Date',
      },
      {
        headerName: 'Sale. Qty',
        field: 'Sale_Qty',
        width: 80,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Sale Qty',
      },
      {
        headerName: 'Free. Qty',
        field: 'Free_Qty',
        width: 80,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Free Qty',
      },
      {
        headerName: 'PTR',
        field: 'Sale_Rate',
        width: 50,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'PTR',
      },
      {
        headerName: 'Amount',
        field: 'Amt',
        width: 80,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Amount',
      },
    ];
    this.CustomerSalesColumnDefs = [
      {
        headerName: 'Cust Code',
        field: 'Cust_Code',
        width: 100,
        headerTooltip: 'Cust Code',
      },
      {
        headerName: 'Customer Name',
        field: 'Cust_Name',
        width: 190,
        headerTooltip: 'Customer Name',
      },
      {
        headerName: 'Area',
        field: 'Area',
        width: 120,
        headerTooltip: 'Area',
      },
      {
        headerName: 'City',
        field: 'City',
        width: 170,
        headerTooltip: 'City',
      },
      {
        headerName: 'Pincode',
        field: 'Pincode',
        width: 70,
        headerTooltip: 'Pincode',
      },
      {
        headerName: 'Bill No',
        field: 'Bill_No',
        width: 70,
        headerTooltip: 'Bill No',
      },
      {
        headerName: 'Bill Date',
        field: 'Bill_Date',
        width: 70,
        headerTooltip: 'Bill Date',
      },
      {
        headerName: 'Item Code',
        field: 'Product_Code',
        width: 100,
        headerTooltip: 'Item Code',
      },
      {
        headerName: 'Item Name',
        field: 'Product_Desc',
        width: 190,
        headerTooltip: 'Item Name',
      },
      {
        headerName: 'Packsize',
        field: 'Packsize',
        width: 80,
        headerTooltip: 'Packsize',
      },
      {
        headerName: 'Sale. Qty',
        field: 'Sale_Qty',
        width: 80,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Sale Qty',
      },
      {
        headerName: 'Free. Qty',
        field: 'Free_Qty',
        width: 80,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Free Qty',
      },
      {
        headerName: 'PTR',
        field: 'Sale_Rate',
        width: 50,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'PTR',
      },
      {
        headerName: 'Amount',
        field: 'Amt',
        width: 80,
        cellStyle: { 'text-align': 'right' },
        headerTooltip: 'Amount',
      },
    ];
    this.AllowNonMovingColumnDefs = [
    {
      headerName: 'Code',
      field: 'Product_Code',
      width: 100,
      headerTooltip: 'Code',
    },
    {
      headerName: 'Item Name',
      field: 'Product_Desc',
      width: 190,
      headerTooltip: 'Item Name',
    },
    {
      headerName: 'Pack',
      field: 'Packsize',
      width: 120,
      headerTooltip: 'Pack',
    },
    {
      headerName: 'Op Qty',
      field: 'OPQty',
      width: 100,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'Op Qty',
    },
    {
      headerName: 'Sal Qty',
      field: 'SaleQty',
      width: 100,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'Sal Qty',
    },
    {
      headerName: 'Bal Qty',
      field: 'Balance',
      width: 100,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'Bal Qty',
    },
    {
      headerName: 'Return Qty',
      field: 'ReturnQty',
      width: 100,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'Return Qty',
    },
    {
      headerName: 'Sale %',
      field: 'SalesPer',
      width: 80,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'Sale %',
    },
    {
      headerName: 'Last Billed',
      field: 'LastBilled',
      width: 120,
      headerTooltip: 'Last Billed',
    },
    {
      headerName: 'Last Purchased',
      field: 'LastPurchased',
      width: 120,
      headerTooltip: 'Last Purchased',
    },
    {
      headerName: 'P.Rate',
      field: 'PRate',
      width: 80,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'P.Rate',
    },
    {
      headerName: 'Pur Val',
      field: 'PurValue',
      width: 100,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'Pur Val',
    },
  ];
  
  this.AllowNearExpiryColumnDefs = [
    {
      headerName: 'Code',
      field: 'Product_Code',
      width: 100,
      headerTooltip: 'Code',
    },
    {
      headerName: 'Item Name',
      field: 'Product_Desc',
      width: 190,
      headerTooltip: 'Item Name',
    },
    {
      headerName: 'Pack',
      field: 'Packsize',
      width: 120,
      headerTooltip: 'Pack',
    },
    {
      headerName: 'Batch No',
      field: 'Batch_No',
      width: 120,
      headerTooltip: 'Batch No',
    },
    {
      headerName: 'MFG Date',
      field: 'MFG_Date',
      width: 120,
      headerTooltip: 'MFG Date',
    },
    {
      headerName: 'Expiry Date',
      field: 'Expiry_Date',
      width: 120,
      headerTooltip: 'Expiry Date',
    },
    {
      headerName: 'P.Rate',
      field: 'PRate',
      width: 80,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'P.Rate',
    },
    {
      headerName: 'MRP',
      field: 'MRP',
      width: 80,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'MRP',
    },
    {
      headerName: 'Qty',
      field: 'Qty',
      width: 80,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'Qty',
    },
    {
      headerName: 'Expiry Return Days',
      field: 'ExpiryReturnDays',
      width: 150,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'Expiry Return Days',
    },
  ];
  
  this.AllowPendingClaimColumnDefs = [
    {
      headerName: 'Doc No',
      field: 'DocNo',
      width: 150,
      headerTooltip: 'Doc No',
    },
    {
      headerName: 'Doc Date',
      field: 'DocDate',
      width: 120,
      headerTooltip: 'Doc Date',
    },
    {
      headerName: 'Doc Amt',
      field: 'DocAmt',
      width: 100,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'DocAmt',
    },
    {
      headerName: 'Received Amt',
      field: 'ReceivedAmt',
      width: 150,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'Received Amt',
    },
    {
      headerName: 'Adjusted Amt',
      field: 'Adjusted_Amt',
      width: 150,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'Adjusted Amt',
    },
    {
      headerName: 'Balance Amount',
      field: 'BalanceAmount',
      width: 150,
      cellStyle: { 'text-align': 'right' },
      headerTooltip: 'BalanceAmount',
    },
  ];
  }
  ngOnInit() {
    this.checkMRClaimDues();

    this.mrMonthlysales = {};
    this.mrItemsales = {};
    this.mrCustomersales = {};
    this.mrAllowNonMoving = {}
    this.mrAllowNearExpiry = {}
    this.mrAllowPendingClaim = {}
    this.mrMonthlysales.fromdate = new Date();
    this.mrMonthlysales.todate = new Date();
    this.mrMonthlysales.valueBasedOn = 'PTR';
    this.mrItemsales.fromdate = new Date();
    this.mrItemsales.todate = new Date();
    this.mrCustomersales.fromdate = new Date();
    this.mrCustomersales.todate = new Date();
    this.Value_Type = [
      { id: 'PTR', Name: 'PTR' },
      { id: 'MRP', Name: 'MRP' },
      { id: 'PRATE', Name: 'PRATE' },
    ];
    this.monthlysalesdataList = [];
    this.itemcustomersalesdataList = [];
    this.customeritemsalesdataList = [];
    this.AllowNonMovingdataList = [];
    this.AllowNearExpirydataList = [];
    this.AllowPendingClaimdataList = [];
    
    this.overlayNoRowsTemplate = '<h3> No record to show. </h3>';
    $('[data-bs-target="#mr-dashboard"]').addClass('active');
    $('#mr-dashboard').addClass('active show');
    this.initHotkeys();
    this.Fname = this.userInfo.Full_Name.charAt(0);
    this.DivisionList = [];
    this.getdivisionlist();
  }

  toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
  });

  toastWarningMsg(msg: any) {
    this.toast({
      text: 'warning',
      title: msg,
    });
  }

  initHotkeys() {
    this.hotkeyList = [];
    this.hotkeyListModal = [];
    const ctrlf = new Hotkey(
      'ctrl+f',
      (event: KeyboardEvent): boolean => {
        var textbox: any;
        textbox = document.querySelector('#Search_Text_Box_MSS');
        if (textbox) {
          const bound = textbox.getBoundingClientRect();
          if (bound && bound.top) {
            $('#Search_Text_Box_MSS').focus();
          }
        }
        textbox = document.querySelector('#Search_Text_Box_ItemSale');
        if (textbox) {
          const bound = textbox.getBoundingClientRect();
          if (bound && bound.top) {
            $('#Search_Text_Box_ItemSale').focus();
          }
        }
        textbox = document.querySelector('#Search_Text_Box_Cust');
        if (textbox) {
          const bound = textbox.getBoundingClientRect();
          if (bound && bound.top) {
            $('#Search_Text_Box_Cust').focus();
          }
        }
        textbox = document.querySelector('#Search_Text_Box_NV');
        if (textbox) {
          const bound = textbox.getBoundingClientRect();
          if (bound && bound.top) {
            $('#Search_Text_Box_NV').focus();
          }
        }
        textbox = document.querySelector('#Search_Text_Box_NEXP');
        if (textbox) {
          const bound = textbox.getBoundingClientRect();
          if (bound && bound.top) {
            $('#Search_Text_Box_NEXP').focus();
          }
        }
        textbox = document.querySelector('#Search_Text_Box_PC');
        if (textbox) {
          const bound = textbox.getBoundingClientRect();
          if (bound && bound.top) {
            $('#Search_Text_Box_PC').focus();
          }
        }
        return false;
      },
      ['INPUT', 'SELECT', 'TEXTAREA']
    );
    this.hotkeyList.push(ctrlf);
    this.hotkeysService.add(ctrlf);
    this.calculateMSSGridFooter();
    this.calculateItemsSalesGridFooter();
    this.calculateCustSalesGridFooter();
    this.calculateAllowNonMovingGridFooter();
    this.calculateAllowNearExpiryGridFooter();
    this.calculateAllowPendingClaimGridFooter();
  }

  setMonthlySSData(id: number, result: any) {
    if (id == 1) {
      if (result) {
        this.gridApiMonthlySales.hideOverlay();
      } else {
        this.gridApiMonthlySales.showLoadingOverlay();
        return;
      }
      this.monthlysalesdataList = result;
      this.calculateMSSGridFooter();
    } 
    else if (id == 2) {
      if (result) {
        this.gridApiItemSales.hideOverlay();
      } else {
        this.gridApiItemSales.showLoadingOverlay();
        return;
      }
      this.itemcustomersalesdataList = result;
      this.calculateItemsSalesGridFooter();
    } 
    else if (id == 3) {
      if (result) {
        this.gridApiCustomerSales.hideOverlay();
      } else {
        this.gridApiCustomerSales.showLoadingOverlay();
        return;
      }
      this.customeritemsalesdataList = result;
      this.calculateCustSalesGridFooter();
    } 
    else if (id == 4) {
      if (result) {
        this.gridApiAllowNonMoving.hideOverlay();
      } else {
        this.gridApiAllowNonMoving.showLoadingOverlay();
        return;
      }
      this.AllowNonMovingdataList = result;
      this.calculateAllowNonMovingGridFooter();
    } 
    else if (id == 5) {
      if (result) {
        this.gridApiAllowNearExpiry.hideOverlay();
      } else {
        this.gridApiAllowNearExpiry.showLoadingOverlay();
        return;
      }
      this.AllowNearExpirydataList = result;
      this.calculateAllowNearExpiryGridFooter();
    }
    else if (id == 6) {
      if (result) {
        this.gridApiAllowPendingClaim.hideOverlay();
      } else {
        this.gridApiAllowPendingClaim.showLoadingOverlay();
        return;
      }
      this.AllowPendingClaimdataList = result;
      this.calculateAllowPendingClaimGridFooter();
    }

  }

  sleep = (timeOut: number) =>
    new Promise(resolve => {
      setTimeout(resolve, timeOut);
    });

  async onViewReportCallback(
    result: any,
    reportPath: any,
    reportId: number,
    reportFormat: string,
    id: number
  ) {
    try {
      if (reportPath && reportFormat == 'export') {
        this.reportModel[id].isExportLoading = 0;
        window.open(reportPath, '_blank');
        return;
      }
      if (result && reportFormat == 'view') {
        this.setMonthlySSData(id, result);
        this.reportModel[id].isViewLoading = 0;
        return;
      }
      if (this.reportModel[id].repeatCount > 20) {
        console.log(
          `Report Count to get data for ${this.reportModel[id].name} has been exceeded`
        );
        this.reportModel[id].isViewLoading = 0;
        this.reportModel[id].isExportLoading = 0;
        this.reportModel[id].repeatCount = 0;
        return;
      }
      this.reportModel[id].repeatCount += 1;
      await this.sleep(5000);
      this.http
        .get(
          `/api/Manufacturers/getExportRequestQueueForMonthlyMR/${reportId}/${reportFormat}`
        )
        .subscribe(
          (exportResult: any) => {
            if (exportResult.length > 0) {
              if (
                !exportResult[0]['ReporPath'] &&
                exportResult[0]['Status'] === 'COMPLETED' &&
                reportFormat == 'export'
              ) {
                this.reportModel[id].isExportLoading = 0;
                this.toastWarningMsg('No record found');
                return;
              }
              this.onViewReportCallback(
                exportResult[0]['excelResult'],
                exportResult[0]['ReporPath'],
                reportId,
                reportFormat,
                id
              );
            }
          },
          error => {
            this.reportModel[id].isViewLoading = 0;
            this.reportModel[id].isExportLoading = 0;
            console.log(error.error);
            this.setMonthlySSData(id, []);
          }
        );
    } catch (ex) {
      this.reportModel[id].isViewLoading = 0;
      this.reportModel[id].isExportLoading = 0;
      this.setMonthlySSData(id, []);
    }
  }

  async generateExportRequestQueueForMonthlyMR(
    param = {},
    id: number,
    reportFormat: string
  ) {
    try {
      if (reportFormat == 'export') {
        this.reportModel[id].isExportLoading = 1;
      } else {
        this.reportModel[id].isViewLoading = 1;
        this.setMonthlySSData(id, null);
      }
      const data = {
        companyId: this.userInfo.Company_ID,
        unitId: this.userInfo.Unit_ID,
        reportType: 'Export',
        requestedBy: this.userInfo._id,
        status: 'INIT',
        priority: 126,
        reportId: 5991,
        data: [
          {
            reportName: this.reportModel[id].name,
            params: {
              Company_ID: this.userInfo.Company_ID,
              Unit_ID: this.userInfo.Unit_ID,
              Manufacturer_ID: this.userInfo.Manufacturer_ID,
              Division_ID: this.userInfo.Division_ID,
              ...param,
            },
            reportProcedure: this.reportModel[id].procedure,
            reportCaption: this.reportModel[id].name,
          },
        ],
      };

      this.http
        .post('/api/Manufacturers/CheckExportRequestQueueForMonthlyMR', data)
        .subscribe( 
          (exportResult: any) => {
            if (exportResult.length > 0) {
              this.onViewReportCallback(
                exportResult[0]['excelResult'],
                exportResult[0]['ReporPath'],
                exportResult[0].id,
                reportFormat,
                id
              );
            } else {
              this.reportModel[id].isViewLoading = 0;
              this.reportModel[id].isExportLoading = 0;
            }
          },
          error => {
            console.log(error.error);
            this.setMonthlySSData(id, []);
            this.reportModel[id].isViewLoading = 0;
            this.reportModel[id].isExportLoading = 0;
          }
        );
    } catch (ex) {
      this.setMonthlySSData(id, []);
      this.reportModel[id].isViewLoading = 0;
      this.reportModel[id].isExportLoading = 0;
    }
  }

  onMonthlySalesGridReady(params: { api: any; columnApi: any }) {
    this.gridApiMonthlySales = params.api;
    this.gridColumnApiMonthlySales = params.columnApi;
    this.defaultColDefMonthlySales = {
      resizable: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: true,
    };
  }

  onItemSalesGridReady(params: { api: any; columnApi: any }) {
    this.gridApiItemSales = params.api;
    this.gridColumnApiItemSales = params.columnApi;
    this.defaultColDefItemSales = {
      resizable: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: true,
    };
  }

  onCustomerSalesGridReady(params: { api: any; columnApi: any }) {
    this.gridApiCustomerSales = params.api;
    this.gridColumnApiCustomerSales = params.columnApi;
    this.defaultColDefCustomerSales = {
      resizable: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: true,
    };
  }

  onAllowNonMovingGridReady(params: { api: any; columnApi: any }) {
    this.gridApiAllowNonMoving = params.api;
    this.gridColumnApiAllowNonMoving = params.columnApi;
    this.defaultColDefNV = {
      resizable: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: true,
    };
  }

  onAllowNearExpiryGridReady(params: { api: any; columnApi: any }) {
    this.gridApiAllowNearExpiry = params.api;
    this.gridColumnApiAllowNearExpiry = params.columnApi;
    this.defaultColDefNEXP = {
      resizable: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: true,
    };
  }

  onAllowPendingClaimGridReady(params: { api: any; columnApi: any }) {
    this.gridApiAllowPendingClaim = params.api;
    this.gridColumnApiAllowPendingClaim = params.columnApi;
    this.defaultColDefPCLM = {
      resizable: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: true,
    };
  }

  f_chknum(p_value: any) {
    var Val = Number(p_value);
    if (Val) {
      return Val;
    }
    return 0;
  }

  f_chkString(p_value: any) {
    var Val = (p_value ? p_value.toString() : '').trim();
    return Val;
  }

  Get_MR_MSS(reportFormat: 'view' | 'export') {
    if (isNaN(Date.parse(this.mrMonthlysales.fromdate))) {
      this.toastWarningMsg('Invalid From Date!');
      $('#fromdate1').focus();
      return;
    }
    if (isNaN(Date.parse(this.mrMonthlysales.todate))) {
      this.toastWarningMsg('Invalid To Date!');
      $('#todate1').focus();
      return;
    }
    if (
      Date.parse(this.mrMonthlysales.todate) <
      Date.parse(this.mrMonthlysales.fromdate)
    ) {
      this.toastWarningMsg('From date can not be greater than to date!');
      return;
    }
    if (this.f_chkString(this.mrMonthlysales.valueBasedOn) === '') {
      this.toastWarningMsg('Value based on can not be blank!');
      $('#Value_Type [role=combobox] input').focus();
      return;
    }
    var param: any = {
      From_Date: moment(this.mrMonthlysales.fromdate).format('YYYY-MM-DD'),
      To_Date: moment(this.mrMonthlysales.todate).format('YYYY-MM-DD'),
      valueBasedOn: this.mrMonthlysales.valueBasedOn,
    };
    this.generateExportRequestQueueForMonthlyMR(param, 1, reportFormat);
  }

  Get_MR_ItemCustomerSales_Data(reportFormat: 'view' | 'export') {
    if (isNaN(Date.parse(this.mrItemsales.fromdate))) {
      this.toastWarningMsg('Invalid From Date!');
      $('#fromdate2').focus();
      return;
    }
    if (isNaN(Date.parse(this.mrItemsales.todate))) {
      this.toastWarningMsg('Invalid To Date!');
      $('#todate2').focus();
      return;
    }
    if (
      Date.parse(this.mrItemsales.todate) <
      Date.parse(this.mrItemsales.fromdate)
    ) {
      this.toastWarningMsg('From date can not be greater than to date!');
      return;
    }
    var param: any = {
      From_Date: moment(this.mrItemsales.fromdate).format('YYYY-MM-DD'),
      To_Date: moment(this.mrItemsales.todate).format('YYYY-MM-DD'),
      Type: 'Item_Sales',
    };
    this.generateExportRequestQueueForMonthlyMR(param, 2, reportFormat);
  }

  Get_MR_CustomerItemSales_Data(reportFormat: 'view' | 'export') {
    if (isNaN(Date.parse(this.mrCustomersales.fromdate))) {
      this.toastWarningMsg('Invalid From Date!');
      $('#fromdate3').focus();
      return;
    }
    if (isNaN(Date.parse(this.mrCustomersales.todate))) {
      this.toastWarningMsg('Invalid To Date!');
      $('#todate3').focus();
      return;
    }
    if (
      Date.parse(this.mrCustomersales.todate) <
      Date.parse(this.mrCustomersales.fromdate)
    ) {
      this.toastWarningMsg('From date can not be greater than to date!');
      return;
    }
    var param: any = {
      From_Date: moment(this.mrCustomersales.fromdate).format('YYYY-MM-DD'),
      To_Date: moment(this.mrCustomersales.todate).format('YYYY-MM-DD'),
      Type: 'Cust_sales',
    };
    this.generateExportRequestQueueForMonthlyMR(param, 3, reportFormat);
  }
  Get_MR_AllowNonMoving(reportFormat: 'view' | 'export'){
    var param: any = {
      Type: 'AllowNonMoving',
    };
    this.generateExportRequestQueueForMonthlyMR(param, 4, reportFormat);
  }
  Get_MR_AllowNearExpiry(reportFormat: 'view' | 'export'){
    var param: any = {
      Type: 'AllowNearExpiry',
    };
    this.generateExportRequestQueueForMonthlyMR(param, 5, reportFormat);
  }
  Get_MR_AllowPendingClaim(reportFormat: 'view' | 'export'){
    var param: any = {
      Type: 'AllowPendingClaim',
    };
    this.generateExportRequestQueueForMonthlyMR(param, 6, reportFormat);
  }

  calculateMSSGridFooter() {
    var parent = this;
    let TotalRowData: any = {
      Product_Desc: 'Total Count',
      Packsize: 0,
      PTR: 'Total',
      Opening_Qty: 0,
      Purchase_Qty: 0,
      Purchase_Free_Qty: 0,
      Purchase_Value: 0,
      Purchase_Ret_Qty: 0,
      Purchase_Ret_Free_Qty: 0,
      Rqty: 0,
      Sale_Qty: 0,
      Sale_Free_Qty: 0,
      Sale_Value: 0,
      Sale_Ret_Qty: 0,
      Sale_Ret_Free_Qty: 0,
      Other_Qty: 0,
      Closing_Qty: 0,
      Sale_Amount: 0,
      Stock_Amount: 0,
    };
    TotalRowData.Packsize = this.monthlysalesdataList.length;
    TotalRowData.Opening_Qty = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Opening_Qty);
    },
    0).toFixed(2);

    TotalRowData.Purchase_Qty = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Purchase_Qty);
    },
    0).toFixed(2);

    TotalRowData.Purchase_Free_Qty = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Purchase_Free_Qty);
    },
    0).toFixed(2);

    TotalRowData.Purchase_Value = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Purchase_Value);
    },
    0).toFixed(2);

    TotalRowData.Purchase_Ret_Qty = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Purchase_Ret_Qty);
    },
    0).toFixed(2);

    TotalRowData.Purchase_Ret_Free_Qty = this.monthlysalesdataList.reduce(
      function (acc: any, sum: any) {
        return acc + parent.f_chknum(sum.Purchase_Ret_Free_Qty);
      },
      0
    ).toFixed(2);

    TotalRowData.Rqty = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Rqty);
    },
    0).toFixed(2);

    TotalRowData.Sale_Qty = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Sale_Qty);
    },
    0).toFixed(2);

    TotalRowData.Sale_Free_Qty = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Sale_Free_Qty);
    },
    0).toFixed(2);

    TotalRowData.Sale_Value = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Sale_Value);
    },
    0).toFixed(2);

    TotalRowData.Sale_Ret_Qty = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Sale_Ret_Qty);
    },
    0).toFixed(2);

    TotalRowData.Sale_Ret_Free_Qty = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Sale_Ret_Free_Qty);
    },
    0).toFixed(2);

    TotalRowData.Other_Qty = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Other_Qty);
    },
    0).toFixed(2);

    TotalRowData.Closing_Qty = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Closing_Qty);
    },
    0).toFixed(2);

    TotalRowData.Sale_Amount = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Sale_Amount);
    },
    0).toFixed(2);

    TotalRowData.Stock_Amount = this.monthlysalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Stock_Amount);
    },
    0).toFixed(2);

    setTimeout(() => {
      this.gridApiMonthlySales.setPinnedBottomRowData([TotalRowData]);
    }, 300);
  }

  calculateItemsSalesGridFooter() {
    var parent = this;
    let TotalRowData: any = {
      Product_Desc: 'Total Count',
      Packsize: 0,
      Cust_Name: 'Total',
      Sale_Qty: 0,
      Free_Qty: 0,
      Sale_Rate: 0,
      Amt: 0,
    };
    TotalRowData.Packsize = this.itemcustomersalesdataList.length;
    TotalRowData.Sale_Qty = this.itemcustomersalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Sale_Qty);
    },
    0).toFixed(2);

    TotalRowData.Free_Qty = this.itemcustomersalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Free_Qty);
    },
    0).toFixed(2);

    TotalRowData.Sale_Rate = this.itemcustomersalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Sale_Rate);
    },
    0).toFixed(2);

    TotalRowData.Amt = this.itemcustomersalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Amt);
    },
    0).toFixed(2);

    setTimeout(() => {
      this.gridApiItemSales.setPinnedBottomRowData([TotalRowData]);
    }, 300);
  }

  calculateCustSalesGridFooter() {
    var parent = this;
    let TotalRowData: any = {
      Cust_Name: 'Total Count',
      Area: 0,
      Product_Desc: 'Total',
      Sale_Qty: 0,
      Free_Qty: 0,
      Sale_Rate: 0,
      Amt: 0,
    };
    TotalRowData.Area = this.customeritemsalesdataList.length;
    TotalRowData.Sale_Qty = this.customeritemsalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Sale_Qty);
    },
    0).toFixed(2);

    TotalRowData.Free_Qty = this.customeritemsalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Free_Qty);
    },
    0).toFixed(2);

    TotalRowData.Sale_Rate = this.customeritemsalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Sale_Rate);
    },
    0).toFixed(2);

    TotalRowData.Amt = this.customeritemsalesdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Amt);
    },
    0).toFixed(2);

    setTimeout(() => {
      this.gridApiCustomerSales.setPinnedBottomRowData([TotalRowData]);
    }, 300);
  }

  calculateAllowNonMovingGridFooter() {
    var parent = this;
    let TotalRowData: any = {
      Product_Desc: this.AllowNonMovingdataList.length ? "Total Count : " + this.AllowNonMovingdataList.length : "Total Count : " + 0 ,
      Packsize: 'Total',
      OPQty: 0,
      SaleQty: 0,
      Balance: 0,
      ReturnQty: 0,
      PurValue: 0
    };
    TotalRowData.OPQty = this.AllowNonMovingdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.OPQty);
    },
    0).toFixed(2);

    TotalRowData.SaleQty = this.AllowNonMovingdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.SaleQty);
    },
    0).toFixed(2);

    TotalRowData.Balance = this.AllowNonMovingdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Balance);
    },
    0).toFixed(2);

    TotalRowData.ReturnQty = this.AllowNonMovingdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.ReturnQty);
    },
    0).toFixed(2);

    TotalRowData.PurValue = this.AllowNonMovingdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.PurValue);
    },
    0).toFixed(2);

    setTimeout(() => {
      this.gridApiAllowNonMoving.setPinnedBottomRowData([TotalRowData]);
    }, 300);
  };

  calculateAllowNearExpiryGridFooter(){
    var parent = this;
    let TotalRowData: any = {
      Product_Desc: this.AllowNearExpirydataList.length ? "Total Count : " + this.AllowNearExpirydataList.length : "Total Count : " + 0 ,
      Packsize: 'Total',
      Qty: 0
    };
    TotalRowData.Qty = this.AllowNearExpirydataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Qty);
    },
    0).toFixed(2);

    setTimeout(() => {
      this.gridApiAllowNearExpiry.setPinnedBottomRowData([TotalRowData]);
    }, 300);
  }

  calculateAllowPendingClaimGridFooter(){
    var parent = this;
    let TotalRowData: any = {
      DocNo: this.AllowPendingClaimdataList.length ? "Total Count : " + this.AllowPendingClaimdataList.length : "Total Count : " + 0 ,
      DocDate: 'Total',
      DocAmt: 0,
      ReceivedAmt: 0,
      Adjusted_Amt: 0,
      BalanceAmount: 0
    };
    TotalRowData.DocAmt = this.AllowPendingClaimdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.DocAmt);
    },
    0).toFixed(2);
    TotalRowData.ReceivedAmt = this.AllowPendingClaimdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.ReceivedAmt);
    },
    0).toFixed(2);
    TotalRowData.Adjusted_Amt = this.AllowPendingClaimdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.Adjusted_Amt);
    },
    0).toFixed(2);
    TotalRowData.BalanceAmount = this.AllowPendingClaimdataList.reduce(function (
      acc: any,
      sum: any
    ) {
      return acc + parent.f_chknum(sum.BalanceAmount);
    },
    0).toFixed(2);

    setTimeout(() => {
      this.gridApiAllowPendingClaim.setPinnedBottomRowData([TotalRowData]);
    }, 300);
  }

  onSearchTextBoxFilterChanged(type: any) {
    if (type === 'MSS') {
      let value: any = $('input#Search_Text_Box_MSS').val();
      this.gridApiMonthlySales.setQuickFilter(value);
    } else if (type === 'Item_Sales') {
      let value: any = $('input#Search_Text_Box_ItemSale').val();
      this.gridApiItemSales.setQuickFilter(value);
    } else if (type === 'NV') {
      let value: any = $('input#Search_Text_Box_NV').val();
      this.gridApiAllowNonMoving.setQuickFilter(value);
    } else if (type === 'NEXP') {
      let value: any = $('input#Search_Text_Box_NEXP').val();
      this.gridApiAllowNearExpiry.setQuickFilter(value);
    } else if (type === 'PC') {
      let value: any = $('input#Search_Text_Box_PC').val();
      this.gridApiAllowPendingClaim.setQuickFilter(value);
    } else {
      let value: any = $('input#Search_Text_Box_Cust').val();
      this.gridApiCustomerSales.setQuickFilter(value);
    }
  };

  printData(option){
    if(option == 'mr-monthlysales'){
      this.OnMRmonthlysalesModalPrint();
    }else if(option == 'mr-itemsales'){
      this.OnMRitemsalesModalPrint();
    }
    else if(option == 'mr-customersales'){
      this.OnMRcustomersalesModalPrint();
    }
    else{
      this.OnMRcustomersalessummaryModalPrint();
    }
   

  };

  OnMRmonthlysalesModalPrint(){
    var data = {
      "FileName": "Get_MR_MSS"
      , "FormatType": "pdf"
      , "params": {
        Manufacturer_ID: this.userInfo.Manufacturer_ID,
        Division_ID: this.userInfo.Division_ID,
        From_Date:moment(this.mrMonthlysales.fromdate).format('YYYY-MM-DD'),
        To_Date: moment(this.mrMonthlysales.todate).format('YYYY-MM-DD'),
        valueBasedOn:this.mrMonthlysales.valueBasedOn,
        Company_ID: this.userInfo.Company_ID,
        Unit_ID:this.userInfo.Unit_ID
      }
  };
      this.busy = this.commonReportService.GetJasperReportForMRUser(data).subscribe(response => {
        var filename = '';
        if (response) {
            var error = '';
            error = response["error"];
            filename = response["FilePath"];
            if (filename.length > 0) {
                window.open(filename, '_blank');
            }
        }
    });
  };

  OnMRitemsalesModalPrint(){
    var data = {
      "FileName": "Get_MR_ItemCustomerSales_Data"
      , "FormatType": "pdf"
      , "params": {
        Manufacturer_ID: this.userInfo.Manufacturer_ID,
        Division_ID: this.userInfo.Division_ID,
        From_Date:moment(this.mrItemsales.fromdate).format('YYYY-MM-DD'),
        To_Date: moment(this.mrItemsales.todate).format('YYYY-MM-DD'),
        Type: 'Item_Sales',
        Company_ID: this.userInfo.Company_ID,
        Unit_ID:this.userInfo.Unit_ID
      }
  };
    this.busy = this.commonReportService.GetJasperReportForMRUser(data).subscribe(response => {
      var filename = '';
      if (response) {
          var error = '';
          error = response["error"];
          filename = response["FilePath"];
          if (filename.length > 0) {
              window.open(filename, '_blank');
          }
      }
      });
  };

  OnMRcustomersalessummaryModalPrint(){
    var data = {
      "FileName": "Get_MR_ItemCustomerSalesSummary_Data"
      , "FormatType": "pdf"
      , "params": {
        Manufacturer_ID: this.userInfo.Manufacturer_ID,
        Division_ID: this.userInfo.Division_ID,
        From_Date:moment(this.mrCustomersales.fromdate).format('YYYY-MM-DD'),
        To_Date: moment(this.mrCustomersales.todate).format('YYYY-MM-DD'),
        Type: 'Cust_sales',
        Company_ID: this.userInfo.Company_ID,
        Unit_ID:this.userInfo.Unit_ID
      }
  };
      this.busy = this.commonReportService.GetJasperReportForMRUser(data).subscribe(response => {
        var filename = '';
        if (response) {
            var error = '';
            error = response["error"];
            filename = response["FilePath"];
            if (filename.length > 0) {
                window.open(filename, '_blank');
            }
        }
        });

  }

  OnMRcustomersalesModalPrint(){
    var data = {
      "FileName": "Get_MR_ItemCustomerSales_Data"
      , "FormatType": "pdf"
      , "params": {
        Manufacturer_ID: this.userInfo.Manufacturer_ID,
        Division_ID: this.userInfo.Division_ID,
        From_Date:moment(this.mrCustomersales.fromdate).format('YYYY-MM-DD'),
        To_Date: moment(this.mrCustomersales.todate).format('YYYY-MM-DD'),
        Type: 'Cust_sales',
        Company_ID: this.userInfo.Company_ID,
        Unit_ID:this.userInfo.Unit_ID
      }
  };
      this.busy = this.commonReportService.GetJasperReportForMRUser(data).subscribe(response => {
        var filename = '';
        if (response) {
            var error = '';
            error = response["error"];
            filename = response["FilePath"];
            if (filename.length > 0) {
                window.open(filename, '_blank');
            }
        }
        });

  }

  DivisionList:any = [];
  getdivisionlist(){
    // this.DivisionList = [];
    let data = {"MR_ID": this.userInfo._id , "Manufacturer_ID": this.userInfo.Manufacturer_ID};
    this.busy = this.http.post('/api/Manufacturers/GetMRDivisionList', data)
    .subscribe(response => {
        this.DivisionList = response;
        setTimeout(() => {
          this.Division_ID = this.userInfo.Division_ID;
          //console.log('division::',this.DivisionList);
        }, 500);
    })
  }

  setselectedDivision(e){
    if(e !=undefined){ 
      let storage = localStorage.getItem('user');
      let user = JSON.parse(storage);
      user.Division_ID = e.Division_ID;
      user.Division_Name = e.Division_Name;
      localStorage.setItem('user', JSON.stringify(user));
      setTimeout(() => {
        this.userInfo.Division_ID = e.Division_ID;
        this.userInfo.Division_Name = e.Division_Name;
      }, 500);
    }
  }

  checkMRClaimDues(){
    this.busy = this.http.get('/api/Manufacturers/CheckMRCreditDaysForLogin/' + JSON.stringify({ "MR_ID": this.userInfo._id, "Manufacturer_ID": this.userInfo.Manufacturer_ID, "Company_ID": this.userInfo.Company_ID,"Unit_ID":this.userInfo.Unit_ID}))
    .subscribe((response: any) => {
        var result_response = response;
        if(result_response[0].Login == 0){
          Swal({
            title: result_response[0].Loginmsg,
            // text: "Do you want to continue?",
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ok'
          }).then(result => {
              if (result.value) {
                // this.Router.navigateByUrl('/login');
                this.router.navigate(['/login']);
                    localStorage.clear();
              }
              //this.Router.navigateByUrl('/login');
              this.router.navigate(['/login']);
              localStorage.clear();
              return;
          });
        }
    })
  }
}
